import { createRouter } from "@tanstack/react-router";

import { routeTree } from "@/routeTree.gen";

import { queryClient } from "./queryClient";

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  // Свежесть данных решает Query, а не роутер.
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
  // Свойства маршрута для оболочки (routes/__root.tsx).
  interface StaticDataRouteOption {
    // Страница открывается без входа. По умолчанию все страницы требуют входа.
    isPublic?: boolean;
  }
}
